import Lobby from "screens/private/lobby/index-config";
export default Lobby;
